import React from 'react'
import ModalBasic from '../../component/ModalBasic';
import { AgGridReact } from "ag-grid-react";
import TextInput from '../../../components/UIComponent/TextInput';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';




function EmployeePopUp(props) {
    const itemColdefs = [
        {
            field: "employeeName",
            headerName: "Employee name",
            minWidth: window.innerWidth * 0.15,
            flex: 1.5,
            filter: true,
        },
        {
            field: "allocatedQty",
            headerName: "Allocated Qty",
            minWidth: window.innerWidth * 0.08,
            flex: 0.8,
            filter: true,
        },
        {
            field: "Action",
            headerName: "Action",
            minWidth: window.innerWidth * 0.05,
            flex: 0.5,
            headerClass: "header-center",
            filter: false,
            floatingFilter: false,
            cellClass: "action-col !p-0 flex items-center justify-center",
            cellRenderer: (params) => (
                <button
                    onClick={() => props.deleteEmployeeWiseQty(params)}
                    className='delete-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                >
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            ),
        }
    ];
    return (
        <ModalBasic
            id="process-popup"
            classParams="!w-[890px] overflow-y-auto p-5 pt-2.5"
            modalOpen={props.isProcessOpen}
            setModalOpen={props.setProcessModel}
        >
            <div className='input-fields pt-2.5'>
                <span className="text-blue text-[16px] font-semibold">Employee details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp col-span-2'>
                        <label>Employee</label>
                        <MultiSelectDropdown
                            drpIdentity="Select employee"
                            options={props.employeeList}
                            value={props.employeeObject.idEmployee > 0 ? props.employeeList.find(x => x.value === props.employeeObject.idEmployee) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdownForEmployee(event, "idEmployee")
                            }
                            className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Allocated Qty</label>
                        <TextInput type='text'
                            id='allocatedQty' name='allocatedQty'
                            value={props.employeeObject.allocatedQty}
                            handleChange={(event) => props.handleChangeForEmployee(event, 'allocatedQty')}
                            className={props.validState?.error?.allocatedQty !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Total Pass Qty</label>
                        <TextInput type='text'
                            id='passQty' name='passQty'
                            value={props.passQty}
                            handleChange={(event) => props.handleChangeForEmployee(event, 'passQty')}
                            className={props.validState?.error?.passQty !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item Rate</label>
                        <TextInput type='text'
                            id='processRates' name='processRates'
                            value={props.employeeObject.processRates}
                            handleChange={(event) => props.handleChangeForEmployee(event, 'processRates')}
                            className={props.validState?.error?.processRates !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5'>
                        <button className="save-btn btns" onClick={() => props.addEmployees()}>Add</button>
                    </div>
                </div>
            </div>
            <div className="pending-table pt-2.5">
                <span className="text-blue text-[16px] font-semibold">Item process details</span>
                <div className="table-inner mt-[10px] overflow-y-auto"
                    style={{ height: "265px" }}>
                    <AgGridReact
                        rowData={props.employeeWiseQtyList}
                        columnDefs={itemColdefs}
                    // onCellClicked={props.handleCellClickItemList}
                    //onGridReady={props.onGridReady}
                    //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                    //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                    />
                </div>
            </div>
            <div className='btn-grp flex gap-2.5 mt-5'>
                <button className="save-btn btns" onClick={() => props.addAllocatedQtyEmployeeWise()}>Save</button>
            </div>
        </ModalBasic>
    )
}

export default EmployeePopUp